/* Copyright (C) ZibatRan, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Zibatran development team, Dec 2020
 */
import React, {useEffect, useState} from 'react';
import {useHistory, useLocation, useParams} from 'react-router-dom'
import {getData, protectedPostData} from "../../api/Interface";
import {GlobalAPIRoutes, PublicAPIRoutes, StudentAPIRoutes, TeacherAPIRoutes} from "../../api/APIRoutes";
import {Button, Input, Form, Select, Tooltip} from "antd";
import loadingWhite from "../../assets/images/loading_white.svg";
import Loader from "../../components/global/loaders/Loader";
import TinyEditor from "../../components/global/TinyEditor";
import DatePicker from "react-datepicker2";
import moment from "jalali-moment";
import CkEditorCmp from "../../components/global/CkEditorCmp";
import Num2persian from 'num2persian';
import {Option} from "antd/es/mentions";
import CustomConfirmationSecond from "../../components/global/CustomConfirmationSecond";


const CheckOut = () => {

    const history = useHistory();
    let { lessonname, action, id, sessioncode} = useParams();
    let eventId=id;

    const [EventSessionData, setEventSessionData] = useState();
    const [EventData, setEventData] = useState();
    const [Wallet, setWallets] = useState();
    const [DisableButton, setDisableButton] = useState('');
    const [SessionNumberMessage, setSessionNumberMessage] = useState();
    const [loading, setLoading] = useState(false);
    const [description, setDescription] = useState();
    const handleEditorChange = (content) => {
        setDescription(content);
    };


    useEffect(() => {
        getEventSession()
        getEvent()
        getWallet()
    }, [sessioncode]);
    //
    // useEffect(() => {
    //     checkSubmitButton()
    // }, [EventSessionData,EventData]);

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery();

    const sendPost = async (e) => {
        setLoading(true);
        const data = new FormData();
        data.append("start_time", (new Date(e.start_time).getTime() / 1000));
        data.append("description", description);
        data.append("address", e.address);
        data.append("eventId", eventId);
        let response = await protectedPostData(TeacherAPIRoutes.MyEventsSessionCreate, data);
        if (response) {
            await getEventSession()
        }
        setLoading(false);
    };


    const getEventSession = async () => {
        setLoading(true);
        let response = await getData(PublicAPIRoutes.GetEventsItem +'/'+eventId+ "?page=" + (query.get("page") ? query.get("page") : 1));
        if (response) {
            setEventSessionData(response.data);
            checkSubmitButton()
        }
        setLoading(false);

    };

    const getWallet = async () => {
        setLoading(true);
        const data = new FormData();
        let response = await protectedPostData(StudentAPIRoutes.Wallet+ query.get("page"), data, false);
        if (response) {
            setWallets(response.data);
        }
        setLoading(false);

    };

    const getEvent = async () => {
        setLoading(true);
        let response = await getData(PublicAPIRoutes.GetEventsItem+'/'+eventId);
        if (response) {
            setEventData(response.data);

        }
        setLoading(false);

    };

    function checkSubmitButton(){
        if(EventData && EventSessionData){
            if(EventSessionData.data.length === EventData.sessionNumber){
                setDisableButton('disable');
            }else{
                setDisableButton('');
            }

        }
    }

    function Account_difference(){
        if(Wallet && EventData ){
            if(Wallet.user.wallet.balance >= EventData.price)
            {
                return 0;
            }
            return EventData.price-Wallet.user.wallet.balance;
        }else {
            return false;
        }
    }
    // setSessionNumberMessage('test');

    // function setSessionNumberMessages () {
    //             let numberSession=EventData.sessionNumber-2;
    //     setSessionNumberMessage('test');
    //             // setSessionNumberMessage(numberSession  + ' از ' + EventData.sessionNumber)
    //
    // }


    return (

        <div className="row col-xl-12 col-lg-12 col-md-12 col-12 justify-content-center">


            {loading && <Loader/>}
            <div className="row col-xl-12 col-lg-12 col-md-12 col-12 classList">
                <span id="title" className="col-xl-12 col-lg-12 col-md-12 col-12 themeColor p-3">
                   فاکتور
                </span>
                <table className="table table-hover text-center">
                    <thead>
                    <tr>
                        <th scope="col">عنوان</th>
                        <th scope="col">قیمت</th>
                        <th scope="col">موجودی حساب</th>
                        <th scope="col">مبلغ قابل پرداخت</th>
                        <th scope="col">عملیات</th>
                    </tr>
                    </thead>

                    <tbody>

                    <td>
                        {EventData && EventData.title}
                    </td>
                    <td>
                        {EventData && EventData.price} تومان
                    </td>
                    <td>
                        {Wallet && Wallet.user.wallet.balance} تومان
                    </td>
                    <td>
                        {Wallet && EventData && Account_difference()} تومان
                    </td>
                    <td>
                        <button className="btn btn-success" onClick={(e) => {
                            e.preventDefault();window.location.href='/dashboard/main/wallet?event_id='+id+'&custom_amount='+Account_difference()
                        }}>خرید</button>
                    </td>

                    </tbody>
                </table>
            </div>
        </div>


    )


};

export default CheckOut;
